<div class="page">

  <div class="layout">

    <!-- =========================
         DESKTOP SIDEBAR
         ALWAYS OPEN
    ========================== -->

    <aside class="desktop-sidebar">

      <app-sidebar>
      </app-sidebar>

    </aside>


    <!-- =========================
         MAIN CONTENT
    ========================== -->

    <main class="main-content">

      <!-- =====================================================
           হোমপেজের সেকশনগুলো — ক্রম, দেখানো/লুকানো, টাইটেল সবই
           অ্যাডমিন → হোমপেজ ডিজাইন থেকে ঠিক হয়।
           প্রতিটা সেকশনের ঠিক পরে একটা ব্যানার স্লট (AFTER_<সেকশন>) আছে;
           সেখানে ব্যানার না দিলে স্লটটা সম্পূর্ণ ফাঁকা থাকে (কোনো জায়গা নেয় না)।
      ====================================================== -->

      <ng-container *ngIf="!currentSearch">

        <ng-container *ngFor="let s of visibleSections; trackBy: trackSection">

          <ng-container [ngSwitch]="s.sectionKey">

            <!-- মূল ব্যানার -->
            <app-banner *ngSwitchCase="'HERO'"></app-banner>

            <!-- ফিচার বার -->
            <app-features *ngSwitchCase="'FEATURES'"></app-features>

            <!-- পপুলার ক্যাটাগরি -->
            <ng-container *ngSwitchCase="'POPULAR_CATEGORIES'">

            <section
              class="popular-section"
              *ngIf="popularCategories.length > 0"
            >

              <h2>
                🔥 {{ sectionTitle(s) }}
              </h2>

              <div class="popular-grid-container">

                <div class="popular-grid">

                  <div
                    class="popular-card"
                    *ngFor="let c of limitedPopularCategories(s)"
                    (click)="onCategory(c)"
                  >

                    <div class="popular-image">

                      <div class="popular-image-inner">

                        <img
                          loading="lazy"
                          decoding="async"
                          [src]="getCategoryImage(c.imageUrl || c.image_url)"
                          (error)="onImgError($event)"
                        />

                      </div>

                    </div>

                    <p>
                      {{ categoryName(c) }}
                    </p>

                  </div>

                </div>

              </div>

            </section>

            </ng-container>

            <!-- হট ডিলস -->
            <app-product-section
              *ngSwitchCase="'HOT_DEALS'"
              [titleBn]="s.titleBn || 'হট ডিলস'"
              [titleEn]="s.titleEn || 'Hot Deals'"
              seeAllLink="/offers"
              [rows]="s.itemLimit || 2"
              [products]="hotDeals">
            </app-product-section>

            <!-- রেকমেন্ডেড -->
            <app-product-section
              *ngSwitchCase="'RECOMMENDED'"
              [titleBn]="s.titleBn || 'রেকমেন্ডেড'"
              [titleEn]="s.titleEn || 'Recommended'"
              [rows]="s.itemLimit || 2"
              [products]="recommended">
            </app-product-section>

            <!-- ট্রেন্ডিং -->
            <app-product-section
              *ngSwitchCase="'TRENDING'"
              [titleBn]="s.titleBn || 'ট্রেন্ডিং'"
              [titleEn]="s.titleEn || 'Trending'"
              [rows]="s.itemLimit || 2"
              [products]="trending">
            </app-product-section>

            <!-- শপ অ্যান্ড গেট মোর -->
            <app-shop-more
              *ngSwitchCase="'SHOP_MORE'"
              [title]="sectionTitle(s, true)">
            </app-shop-more>

            <!-- পপুলার ব্র্যান্ডস -->
            <app-popular-brands
              *ngSwitchCase="'POPULAR_BRANDS'"
              [title]="sectionTitle(s, true)">
            </app-popular-brands>

          </ng-container>

          <!-- এই সেকশনের ঠিক পরের ব্যানার (না দিলে ফাঁকা) -->
          <app-ad-slot [slot]="'AFTER_' + s.sectionKey"></app-ad-slot>

        </ng-container>

      </ng-container>

<div *ngIf="currentSearch">

  <!-- সার্চ রেজাল্টের ফিল্টার বার -->
  <app-filter-sidebar
    class="search-filter-bar"
    *ngIf="searchBase.length > 0"
    [products]="searchBase"
    (filtersChanged)="onSearchFiltersChanged($event)">
  </app-filter-sidebar>

  <div
    class="search-filter-spacer"
    *ngIf="searchBase.length > 0">
  </div>

  <div class="product-grid">

    <article
      class="product-card"
      [class.out-product]="p.stock <= 0"
      *ngFor="
        let p of filtered;
        trackBy: trackByProduct
      "
      (click)="openProduct(p.id)">

      <div class="product-image">

        <div
          class="out-badge"
          *ngIf="p.stock <= 0">

          {{ t('outOfStock') }}

        </div>

        <img
          loading="lazy"
          decoding="async"
          [src]="getImage(p.imageUrl || p.image_url || p.imageUrl1)"
          (error)="onImgError($event)"
        />

        <button
          type="button"
          class="add-btn"
          *ngIf="p.stock > 0"
          (click)="addToCart(p,$event)">

          +

        </button>

      </div>

      <div class="product-info">

        <div class="price-line">

          <span class="price">
            {{ getFinalPrice(p) | bnNumber:'৳' }}
          </span>

          <span
            class="old-price"
            *ngIf="p.discount">

            {{ p.price | bnNumber:'৳' }}

          </span>

        </div>

        <h3>
          {{ languageService.productName(p) }}
        </h3>

        <p
          class="unit"
          *ngIf="p.quantity && p.unit">

          {{ p.quantity | bnNumber }}
          {{ languageService.translateUnit(p.unit) }}

        </p>

        <p
          class="unit"
          *ngIf="!p.quantity && p.unit">

          {{ languageService.translateUnit(p.unit) }}

        </p>

        <div class="delivery">

          <span>
            ◷ {{ t('deliveryOneHour') }}
          </span>

        </div>

      </div>

    </article>

  </div>

</div>

    </main>


    <!-- =========================
         MOBILE ORDER BAR
    ========================== -->

    <div class="mobile-order-bar">

      <a
        [href]="'https://wa.me/' + whatsappNumber"
        target="_blank"
        rel="noopener noreferrer"
        class="chat-btn"
      >
        💬
      </a>


      <button
        type="button"
        class="order-btn"
      >
        {{ t('placeOrder') }}
      </button>

    </div>

  </div>

</div>


<!-- =========================
     FOOTER
========================== -->

<app-footer>
</app-footer>